module.exports = __webpack_public_path__ + "img/collection-weddingRingsWomen.ddfbd1b.webp";